import CardPage from './pages/CardPage';

function App() {
  return (
    <div className='App'>
      <CardPage />
    </div>
  );
}

export default App;
